/** Nazivi koraka čarobnjaka na koje vode gumbi "Uredi" — moraju odgovarati ContactEditCard. */
export const CONTACT_SUMMARY_STEPS = {
  info: "Detalji",
  emails: "Email",
  phones: "Telefon",
  addresses: "Adrese",
  notes: "Bilješke",
  pictures: "Slike",
};
